import React from 'react'
import { useNavigate } from 'react-router-dom'
import { NotFoundButton, NotFoundContent, NotFoundImg, NotFoundText, NotFoundTitle, NotFoundWrapper } from './styles'
import MainContentDiv from '../../components/templates/MainContent'
import SearchContainer from '../../components/organisms/SearchContainer'
import Search from '../Search'
import SeverErrorImg from '../../assets/img/500-sever-error.png'

function ServerError() {
  const navigate = useNavigate()
  const onClickBack = () => {
    navigate(-1)
  }

  return (
    <MainContentDiv>
      <SearchContainer>
        <Search />
      </SearchContainer>
      <NotFoundWrapper>
        <NotFoundContent>
          <NotFoundImg alt="SeverError_Img" src={SeverErrorImg} />
          <br />
          <NotFoundTitle>500 Server error</NotFoundTitle>
          <NotFoundText>Oops something went wrong.</NotFoundText>
          <NotFoundButton onClick={onClickBack}>Back</NotFoundButton>
        </NotFoundContent>
      </NotFoundWrapper>
    </MainContentDiv>
  )
}

export default ServerError
